import { DataTable } from '@/components/ui/DataTable';
import { Button } from '@/components/ui/Button';
import { useFailedPayments, useRetryPayment } from '@/hooks/useAdminBilling';
import type { AdminInvoice } from '@/types/admin.types';
import { formatCurrency, formatDateTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';
import { RotateCcw } from 'lucide-react';

const columnHelper = createColumnHelper<AdminInvoice>();

export function FailedPaymentsTable() {
  const { data, isLoading } = useFailedPayments({});
  const retry = useRetryPayment();
  // Paginated list: API returns { data: [...], pagination: {...} }
  const invoices = data?.data || [];

  const columns = [
    columnHelper.accessor('invoiceNumber', {
      header: 'Facture',
      cell: (info) => <span className="font-medium text-neutral-900 dark:text-neutral-200">{info.getValue()}</span>,
    }),
    columnHelper.accessor('organisationName', {
      header: 'Organisation',
      cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
    }),
    columnHelper.accessor('amountTTC', {
      header: 'Montant',
      cell: (info) => <span className="text-neutral-700 dark:text-neutral-300">{formatCurrency(info.getValue())}</span>,
    }),
    columnHelper.accessor('createdAt', {
      header: 'Date',
      cell: (info) => <span className="text-xs text-neutral-500">{formatDateTime(info.getValue())}</span>,
    }),
    columnHelper.display({
      id: 'actions',
      header: '',
      cell: (info) => (
        <Button
          variant="outline"
          size="sm"
          icon={<RotateCcw className="h-3 w-3" />}
          onClick={(e) => { e.stopPropagation(); retry.mutate(info.row.original.uuid); }}
          loading={retry.isPending}
        >
          Relancer
        </Button>
      ),
    }),
  ];

  return <DataTable columns={columns} data={invoices} loading={isLoading} emptyMessage="Aucun paiement échoué" />;
}
